export default [{
    header: 'Usuarios',
    icon: 'UsersIcon',
    children: [
        {
            title: 'Lista',
            route: 'users-list',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'users'
        },
        {
            title: 'Nuevo',
            route: 'users-create',
            icon: 'PlusSquareIcon',
            action: 'create',
		    resource: 'users'
        }
    ]
}];